<template>
  <v-sheet class="topics-section pt-6 pt-sm-10 pt-md-15" color="accent">
    <LoadingWidget v-if="loading" />
    <v-container v-if="!loading && topics && topics.length">
      <v-row justify="center">
        <v-col
          v-for="({ title, img, process }, id) in topics"
          :key="id"
          cols="12"
          md="10"
          class="item"
        >
          <v-row
            align="center"
            class="py-2 py-sm-6 flex-column-reverse flex-md-row"
          >
            <v-col cols="12" md="6">
              <div
                class="
                  text-h3 text-sm-h2
                  primary--text
                  text--lighten-1
                  justify-center
                  d-none d-md-flex
                "
              >
                <span class="item-title">
                  {{ title }}
                </span>
              </div>
              <div class="pb-2">
                <span class="font-weight-bold text-h6"
                  >Processos avaliados:</span
                >
              </div>
              <ul class="item-process-list">
                <li v-for="(item, i) in process" :key="i">{{ item }}</li>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="
                  text-h3 text-sm-h2
                  primary--text
                  text--lighten-1
                  d-flex d-md-none
                  justify-center
                  pb-2
                "
              >
                <span class="item-title">
                  {{ title }}
                </span>
              </div>
              <img class="item-img" width="100%" :src="img" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../../widgets/LoadingWidget.vue";

const _config = {
  mod: "attitudes-award-topics",
};
export default {
  data: () => ({
    loading: true,
    topics: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then((bufferedTopics) => {
        this.topics = bufferedTopics.map(({ id, img, title, process }) => ({
          id,
          img: this.files + img + "?resize=1&w=600",
          title,
          process: JSON.parse(process),
        }));
      })
      .then(() => (this.loading = false));
  },
  computed: {
    about() {
      return this.$rest(_config.mod).item;
    },
  },
  components: { LoadingWidget },
};
</script>

<style lang="scss" scoped>
@media (min-width: 960px) {
  .topics-section .item:nth-child(even) .row {
    flex-direction: row-reverse !important;
  }
}

.topics-section {
  .item {
    &-img {
      object-fit: cover;
      aspect-ratio: 460 / 260;
      border-radius: 8px;
    }
    &-title {
      font-family: "Get Show", cursive;
    }
    .item-process-list li {
      list-style: none;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -13px;
        top: 10px;
        height: 3px;
        width: 3px;
        background-color: #424242;
        border-radius: 50%;
      }
    }
  }
}
</style>
